import { ReactNode } from "react";
import { Box, CloseButton, Heading, useColorModeValue } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { Overline } from "../components";
import DeleteSceneButton from "../pages/SceneDetail/components/DeleteSceneButton";

type PanelHeaderProps = {
  subhead: string;
  heading: string;
  closeLink: string;
  closeLabel: string;
  children: ReactNode
}

export const PanelHeader = ({ subhead, heading, closeLink, closeLabel, children }: PanelHeaderProps) => {
  return (
    <Box px={6} pt={4}>
      <Box display="flex" gap="4">
        <Box flex="1">
          <Overline>{subhead}</Overline>
          <Heading as="h1" fontSize="lg">
            {heading}
          </Heading>
        </Box>
        <Box display="flex" gap="1" alignItems="center">
          <DeleteSceneButton />
          <CloseButton
            display="inline-flex"
            as={Link}
            to={closeLink}
            aria-label={closeLabel}
            title={closeLabel}
          />
        </Box>
      </Box>
      {children}
    </Box>
  );
};
type PanelBodyProps = {
  children: React.ReactNode;
}
export const PanelBody = ({ children }: PanelBodyProps ) => {
  return(
    <Box display="flex" flexDirection="column" gap="6" p={6}>
      {children}
    </Box>
  );
};
type PanelFooterProps = {
  children: React.ReactNode;
}
export const PanelFooter = ({ children }: PanelFooterProps ) => {
  const bgColor = useColorModeValue("base.50", "base.700");
  return(
    <Box display="flex" bg={bgColor} position="sticky" flexShrink={0} bottom={0} flexDirection="column" gap="2" mt="auto" p={6}>
      {children}
    </Box>
  );
};

type PanelProps = {
  children: React.ReactNode;
}
function Panel({ children }: PanelProps) {
  const borderColor = useColorModeValue("base.100a", "base.500");
  return (
    <Box
      overflow="auto"
      display="flex"
      flexDirection="column"
      boxShadow="0 -4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)"
      borderRight="1px solid"
      borderColor={borderColor}
    >
      {children}
    </Box>
  );
}
export default Panel;
